const employeeTypes = {
	PRODUCTION: 'production',
	DELIVERY:'delivery',
	BUILDER: 'builder'
};

export default employeeTypes;